<template>
    <b-modal
        :id="id"
        :title="title"
        centered
        no-close-on-backdrop
        @hidden="close"
    >
        <div class="form-group col-12">
            <label for="selectedCourse">Marathon</label>

            <v-select
                id="selectedCourse"
                v-model="courseId"
                :reduce="course => course.id"
                :options="courses"
                label="name"
                placeholder="Search..."
                :class="{
                    'is-invalid': hasError('courseId')
                }"
                @search="onCourseSearch"
            >
                <template slot="no-options">
                    Start typing to search for a marathon
                </template>
            </v-select>

            <div class="invalid-feedback">
                {{ getError('courseId') }}
            </div>
        </div>

        <template #modal-footer>
            <div class="col-12 d-flex justify-content-between">
                <button
                    type="button"
                    class="btn btn-danger waves-effect waves-light mr-2"
                    @click="close"
                >
                    Close
                </button>
                <button
                    type="submit"
                    class="btn btn-success waves-effect waves-light"
                    @click="move"
                >
                    Move
                </button>
            </div>
        </template>
    </b-modal>
</template>

<script>
import { mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { StatusCodes as HTTP } from 'http-status-codes';

export default {
    props: {
        id: {
            type: String,
            required: false,
            default: 'course-change-course'
        },
        userId: {
            type: String,
            required: false,
            default: ''
        },
        course: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            courseId: '',
            courses: [],
            serverErrors: [],
            title: 'Move user to another marathon'
        };
    },

    validations: {
        courseId: {
            required
        }
    },

    methods: {
        ...mapActions({
            changeCourse: 'courses/changeCourse',
            getCourses: 'courses/index'
        }),

        async onCourseSearch(search, loading) {
            if (search.length) {
                loading(true);

                const { rows: courses } = await this.getCourses({
                    search
                });

                this.courses = courses;

                loading(false);
            }
        },

        async move() {
            this.serverErrors = [];

            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            }

            try {
                await this.changeCourse({
                    id: this.course,
                    userId: this.userId,
                    courseId: this.courseId
                });

                this.$toaster('User has been moved!');

                this.$emit('success', this.userId);

                this.close();
            } catch (error) {
                console.error(error);

                const { response } = error;
                let errorMessage = 'User could not be moved';

                if (response) {
                    const { data, status } = response;

                    if (status === HTTP.UNPROCESSABLE_ENTITY && data) {
                        errorMessage = data;

                        this.$toasterError(errorMessage);

                        return;
                    }

                    if (status === HTTP.BAD_REQUEST && data?.errors) {
                        this.serverErrors = data.errors;

                        this.$toasterError('Recheck your form.');
                    }
                }
            }
        },

        close() {
            this.$bvModal.hide(this.id);
        },

        hasError(key) {
            return (
                this.$v[key].$error ||
                this.serverErrors.find(error => error.param === key)
            );
        },

        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                this.$v,
                this.serverErrors,
                key
            );
        }
    }
};
</script>
